import { MapLayerMouseEvent, PointLike } from 'maplibre-gl';
import { useCallback, useEffect } from 'react';

import { useMapboxContext } from '@/providers/mapbox/MapboxProvider';

import { advancedSearchParcelDots } from '../../mapbox-layers/corelogic';
import Logger from '../../utils/logger';
import zoomToBounds from '../../utils/zoomToBounds';

const useAdvancedSearchResultSelect = () => {
  const { mapInstance: map } = useMapboxContext();

  const onCoreLogicParcelDotClick = useCallback(
    (e: MapLayerMouseEvent) => {
      if (!map) return;

      const rad = 4;

      const bbox: [PointLike, PointLike] = [
        [e.point.x - rad, e.point.y - rad],
        [e.point.x + rad, e.point.y + rad],
      ];

      const features = map.queryRenderedFeatures(bbox, {
        layers: [advancedSearchParcelDots.id],
      });
      const [feature] = features;

      if (feature && feature.properties) {
        if (feature.properties.geometry) {
          try {
            const geometry = JSON.parse(feature.properties.geometry);

            zoomToBounds(map, geometry);
          } catch (err) {
            Logger.error(err);
          }
        }
      }
    },
    [map]
  );

  useEffect(() => {
    if (!map) return;

    map.on('click', advancedSearchParcelDots.id, onCoreLogicParcelDotClick);
  }, [map, onCoreLogicParcelDotClick]);
};

export default useAdvancedSearchResultSelect;
